module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/aero.png?72ad39ae";